<script>
    import {onMount} from 'svelte';
    import {PATH_PREFIX} from '../../apiUrls.js';
    import {get} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    import {submit} from '../Form/utils.js';
    import {validateForm} from '../Form/utils.js';
    import Stepper from '../Stepper/Stepper.svelte';
    import StepperNavigator from '../Stepper/StepperNavigator.svelte';

    import DataTable from '../DataGrid/DataTable.svelte';

    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import Errors from '../Errors.svelte';
    import Modal from '../Modal.svelte';
    import yup, {object, number} from 'yup';

    export let formModalId = 'd2CloneMetadataFiltersForm';
    export let onSubmit = (data) => data;
    export let requireReload = false;
    export let refreshConfigs = false;
    export let branchId = null;

    let filterCloneUrl = `${PATH_PREFIX}/sw/instruction/d2/clone-filter/`; 
    let listUrl = `${PATH_PREFIX}/sw/instruction/d2/branch-configuration-admin/`;

    let errorMessaage = sgettext('$$FAILED_CLONE_FILTERS_TARGET$$');
    let title = sgettext('$$CLONE_METADATA_FILTERS$$');
    let selectedOptions = getDefaultConfig();
    let isValid = true;
    let sending = false;
    let loading = false;
    let fetchedFilters = false;
    let formErrors = null;
    let currentStep = 1;
    let finalStep = 2;
    let configs = [];
    let configuredFilters = [];

    $: branchOptions = [];
    $: filtersToAdd = [];
    $: removedFilters = [];

    let steps = [
        {
            order: 1,
            label: sgettext('$$SELECT_CONFIGURATIONS$$'),
            done: false,
            isValid: true,
            fieldValidations: {
                base_configuration_id: {
                isValid: true,
                errors: '',
                },
                target_configuration_id: {
                    isValid: true,
                    errors: '',
                },
            }
        },
        {
            order: 2,
            label: sgettext('$$CONFIGURE_FILTERS$$'),
            done: false,
            isValid: true,
            errors: [],
        }
    ];

    function getDefaultConfig() {
        return {
            branch_id: branchId,
            base_configuration_id: null,
            target_configuration_id: null,
            fieldValidations: getDefaultConfigFieldIsValid(),
        };
    }


    function getDefaultConfigFieldIsValid() {
        return {
            base_configuration_id: {
                isValid: true,
                errors: '',
            },
            target_configuration_id: {
                isValid: true,
                errors: '',
            },
        };
    }

    let rowSchema = object().shape({
        base_configuration_id: number()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
        target_configuration_id: number()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
    });

    $: {
        if (!selectedOptions.base_configuration_id || !selectedOptions.target_configuration_id) {
            fetchedFilters = false;
        }
    }

    $: {
        if (selectedOptions.base_configuration_id && selectedOptions.target_configuration_id && !fetchedFilters) {
            fetchedFilters = true;
            if (!loading) {
                loading = true;
                fetchFiltersForConfigurations().finally(() => loading = false);
            }
        }
    }

    async function submitForm() {
        sending = true;
        const method = 'POST';
        let url = `${filterCloneUrl}`;

        try {
            let payload = {
                base_configuration_id: selectedOptions.base_configuration_id,
                target_configuration_id: selectedOptions.target_configuration_id,
                filters_to_add: filtersToAdd,
            };

            await handleFormValidation();

            if (filtersToAdd.length === 0){
                handleConfigClose();
            }
            else if (isValid) {
                await submit(url, method, payload);
            }
        } catch (error) {
            formErrors = error?.message || (Object.keys(error || {}).length ? error : errorMessaage);
        } finally {
            sending = false;
            if (!formErrors){
                requireReload = true;
                handleConfigClose(); 
            }
        }
    }

    async function handleFormValidation() {
        try {
            await validateSelectedConfigurations();
            await validateForm(rowSchema, selectedOptions);

            if (currentStep === 1) {
                steps[0].isValid = true;
                currentStep++;
            } else if (currentStep === finalStep) {
                steps[1].isValid = true;
            }
            isValid = true;
            formErrors = null;
        } catch (err) {
            handleValidationError(err);
        }
    }

    async function validateSelectedConfigurations() {
        const baseConfig = configs.find(config => config.id === selectedOptions.base_configuration_id);
        const targetConfig = configs.find(config => config.id === selectedOptions.target_configuration_id);

        if (!baseConfig || !targetConfig) {
            throw new Error(sgettext('$$INVALID_CONFIGURATIONS_SELECTED$$'));
        }

        if (baseConfig.d2_repository !== targetConfig.d2_repository) {
            throw new Error(sgettext('$$SELECTED_CONFIGURATIONS_NOT_REPOSITORY$$'));
        }

        if (baseConfig.id === targetConfig.id) {
            throw new Error(sgettext('$$NOT_CLONE_FILTERS_CONFIGURATION$$'));
        }
    }

    function handleValidationError(err) {
        if (err.inner) {
            err.inner.forEach((er) => {
                selectedOptions.fieldValidations[er.path].isValid = false;
                selectedOptions.fieldValidations[er.path].errors = er.message;
            });
        } else {
            formErrors = err.message;
        }
    }

    async function onSaveAndClose() {
        if (!sending) {
            await submitForm();
        }
    }

    async function handleFormBack() {
        resetForm();
        fetchFiltersForConfigurations();
    }

    function resetForm() {
        selectedOptions = getDefaultConfig();
        currentStep = 1;
        isValid = true;
        loading = false;
        formErrors = null;
        configuredFilters = [];
        branchOptions = [];
        filtersToAdd = [];
        removedFilters = [];
    }

    function handleConfigClose() {
        jQuery(`#${formModalId}`).modal('hide');
    }

    async function fetchExistingConfigs() {
        var url = `${listUrl}`;
        const resp = await get(url);
        const json = await resp.json();
        if (json) {
            const originalConfigs = json['results'];
            configs = originalConfigs.map(config => ({
                d2_repository: config.d2_repository,
                configured_filters: config.configured_filters,
                name: config.branch_full_name,
                id: config.id
            }));
        }
    }

    onMount(() => {
        fetchExistingConfigs(branchId);
        jQuery(`#${formModalId}`).on('hidden.bs.modal', resetForm);
    });

    async function fetchFiltersForConfigurations() {
        let baseConfig = configs.find(config => config.id === selectedOptions.base_configuration_id);
        let targetConfig = configs.find(config => config.id === selectedOptions.target_configuration_id);
        if (baseConfig && baseConfig.configured_filters) {
            configuredFilters = baseConfig.configured_filters;
            filtersToAdd = configuredFilters.filter(baseFilter => {
                return !targetConfig.configured_filters.some(targetFilter => 
                    targetFilter.d2_filter === baseFilter.d2_filter && targetFilter.filter_value === baseFilter.filter_value
                );
            });
            sortFilters(filtersToAdd);
        }
    }


    function sortFilters(filters) {
        filters.sort((i, j) => i.d2_filter - j.d2_filter || i.filter_value.localeCompare(j.filter_value));
    }


    let rowActionsRemove = {
        remove: {
            label: sgettext('$$REMOVE_FILTER$$'),
            iconClass: 'fas fa5-trash fa-fw',
            handler: (_, item)  => {
                removeFilter(item);
            },
        },
    };

    let rowActionsAdd = {
        add: {
            label: sgettext('$$ADD_FILTER$$'),
            iconClass: 'fas fa5-plus fa-fw',
            handler: (_, item) => {
                addBackFilter(item);
            },
        },
    };

    function removeFilter(filter) {
        removedFilters=[filter, ...removedFilters]
        filtersToAdd = filtersToAdd.filter(f => f.id !== filter.id);
        sortFilters(removedFilters);
    }

    function addBackFilter(filter) {
        removedFilters = removedFilters.filter(f => f.id !== filter.id);
        filtersToAdd=[filter, ...filtersToAdd]
        sortFilters(filtersToAdd);
    }

    let columns = {
        filter_display_name: {
            label: sgettext('$$FILTER_NAME$$'),
            width: '30%'
        },
        filter_value: {
            label: sgettext('$$VALUE$$'),
            width: '50%',
        }
    }

    $: {
        if (requireReload) {
            fetchFiltersForConfigurations();
        }
    }

    $: {
        if (refreshConfigs) {
            fetchFiltersForConfigurations();
            fetchExistingConfigs();
            refreshConfigs = false;
        }
    }
</script>

<Modal
  id={formModalId}
  {title}
  extraLarge={currentStep === finalStep}
  backdrop={'static'}
  onCancel={handleConfigClose}
>
  <div slot="body">
    {#if loading}
      <div class="text-center">
        <i class="fas fa-spinner fa-spin" />
      </div>
    {:else}
      <form>
        <div class="stepper">
          <Stepper {steps} bind:currentStep />
        </div>
        {#if formErrors}
          <Errors errors={formErrors} />
        {/if}

        {#if currentStep === 1}
          <div class="filters-diff">
            <ComboSelect
              id={`d2_base_configuration`}
              label={sgettext('$$D2_CONFIGURATION_1$$')}
              key="base_configuration_id"
              options={configs}
              searchable={true}
              selected={selectedOptions.branch_full_name}
              bind:value={selectedOptions.base_configuration_id}
              bind:isValid={selectedOptions.fieldValidations
                .base_configuration_id.isValid}
              bind:errors={selectedOptions.fieldValidations
                .base_configuration_id.errors}
              schema={rowSchema}
            />
            <br />
            <ComboSelect
              id={`d2_target_configuration`}
              label={sgettext('$$D2_CONFIGURATION_2$$')}
              key="target_configuration_id"
              options={configs}
              searchable={true}
              selected={selectedOptions.branch_full_name}
              bind:value={selectedOptions.target_configuration_id}
              bind:isValid={selectedOptions.fieldValidations
                .target_configuration_id.isValid}
              bind:errors={selectedOptions.fieldValidations
                .target_configuration_id.errors}
              schema={rowSchema}
            />
          </div>
        {:else if currentStep === 2}
          {#if sending}
            <div class="text-center">
              <i class="fas fa-spinner fa-spin" />
            </div>
          {:else}
            <div class="filters-diff">
              <h5>{sgettext('$$FILTERS_CLONE$$')}:</h5>
              <DataTable
                {columns}
                rowActions={rowActionsRemove}
                rows={filtersToAdd}
                emptyLabel={sgettext('$$ADDITIONAL_FILTERS_CLONE$$')}
              />
              <br />
              <h5>{sgettext('$$EXCLUDED_FILTERS_1$$')}:</h5>
              <DataTable
                {columns}
                rowActions={rowActionsAdd}
                rows={removedFilters}
                emptyLabel={sgettext('$$EXCLUDED_FILTERS$$')}
              />
            </div>
          {/if}
        {/if}
      </form>
    {/if}
  </div>

  <div slot="footer" class="footer" style="width: 80%; margin: 0 auto;">
    <StepperNavigator
      bind:currentStep
      enableSaveAndAddAnother={false}
      {isValid}
      sending={sending && isValid}
      {finalStep}
      back={handleFormBack}
      next={currentStep === finalStep ? onSaveAndClose : handleFormValidation}
    />
  </div>
</Modal>

<style>
  .filters-diff {
    font-family: Arial, sans-serif;
    border: 1px solid #e0e0e0;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  .filters-diff h3 {
    color: #333;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 15px;
  }

  .filters-diff ul {
    list-style-type: none;
    padding-left: 0;
  }

  .filters-diff li {
    padding: 5px 0;
  }

  .filters-diff button {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    margin-left: 10px;
    cursor: pointer;
  }

  .filters-diff button:hover {
    background-color: #0056b3;
  }
</style>
